const s3URL = 'https://internal.letthecargo.co.uk/public/photos/';
const carGoURL = 'https://internal.letthecargo.co.uk/';
export { s3URL };
export { carGoURL };
